import { Component, Input, ContentChild, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnyCard } from '@models/condition.models';
import { MarkdownPipe } from '@pipes/markdown.pipe';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [CommonModule, MarkdownPipe],
  templateUrl: './text-card.component.html',
  styleUrls: ['./text-card.component.scss'],
})
export class CardComponent {
  @Input() card!: AnyCard;
  @Input() headingLevel: number = 3;

  /** Optional footer content projection */
  @ContentChild('footer', { read: TemplateRef })
  footerTpl?: TemplateRef<unknown>;
}
